export const oneTimeCodeDefaultMaxLength = 16;
export const oneTimeCodeMaxLength = 10;
